// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
// import Button from "@insite/mobius/Button"; // Starter Custom Code
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import injectCss from "@insite/mobius/utilities/injectCss";
import * as cssLinter from "css";
import * as React from "react";
import { FC } from "react";
import styled, { css } from "styled-components";

/* Starter Custom Code - Start */
import getButtonIconField, { ButtonIcon, buttonIconOptions } from "@store/Framework/Common/Fields/Toolkit/buttonIcon";
import getButtonSizeVariantField from "@store/Framework/Common/Fields/Toolkit/buttonSizeVariant";
import getButtonVariantField from "@store/Framework/Common/Fields/Toolkit/buttonVariant";
import getLinkTypeField, { LinkType, linkTypeOptions } from "@store/Framework/Common/Fields/Toolkit/linkType";
import ResponsiveButton, {
    ResponsiveButtonPresentationProps,
} from "@store/Library/Components/Toolkit/ResponsiveButton";
import { widgetWrapperStyles } from "@store/Library/Components/Toolkit/WidgetWrapper";
import { ButtonSizeVariants } from "@store/MobiusOverrides/Button/Button";
import cssProp from "@toolkit/Framework/Common/Utilities/cssProp";
import getCurrentSegmentFromUrl from "@toolkit/Framework/Common/Utilities/getCurrentSegmentFromUrl";
/* Starter Custom Code - End */

const enum fields {
    variant = "variant",
    label = "label",
    link = "link",
    alignment = "alignment",
    customCSS = "customCSS",
    // Starter Custom Code
    sizeVariant = "sizeVariant",
    buttonIcon = "buttonIcon",
    buttonIconPosition = "buttonIconPosition",
    fullWidth = "fullWidth",
    linkType = "linkType",
    fileUrl = "fileUrl",
    openInNewWindow = "openInNewWindow",
}

/* Starter Custom Code - Start */
const variantField = getButtonVariantField(fields.variant);
const sizeVariantField = getButtonSizeVariantField(fields.sizeVariant);
const buttonIconField = getButtonIconField(fields.buttonIcon);
const linkTypeField = getLinkTypeField(fields.linkType);
/* Starter Custom Code - End */

interface OwnProps extends WidgetProps {
    fields: {
        [fields.variant]: "primary" | "secondary" | "tertiary";
        [fields.label]: string;
        [fields.link]: LinkFieldValue;
        [fields.alignment]: string;
        [fields.customCSS]: string;
        // Starter Custom Code
        [fields.sizeVariant]: ButtonSizeVariants;
        [fields.buttonIcon]: ButtonIcon;
        [fields.buttonIconPosition]: "right" | "left";
        [fields.fullWidth]: boolean;
        [fields.linkType]: LinkType;
        [fields.fileUrl]: string;
        [fields.openInNewWindow]: boolean;
    };
}

export interface ButtonStyles {
    wrapperStyles: InjectableCss;
}

/* Starter Custom Code - Start */
const wrapperStyles: InjectableCss = widgetWrapperStyles;
/* Starter Custom Code - End */

export const CmsButton: FC<OwnProps> = ({ fields }) => {
    const history = useHistory();
    const link = useGetLink(fields.link);
    const { isInShell } = useShellContext();

    /* Starter Custom Code - Start */
    const linkType = linkTypeField.useParse(fields.linkType);
    const isFile = linkType === linkTypeOptions.file.id;
    const { title, url } = isFile ? { url: fields.fileUrl, title: getCurrentSegmentFromUrl(fields.fileUrl) } : link;
    /* Starter Custom Code - End */

    // Starter Removed - onClick

    const styles = useMergeStyles("button", { wrapperStyles });

    const customCssWrapper = {
        css: css`
            ${styles?.wrapperStyles?.css /* Starter Custom Code */}
            ${fields.customCSS}
        `,
    };

    /* Starter Custom Code - Start */
    const buttonStyles: ResponsiveButtonPresentationProps = React.useMemo(() => {
        return {
            variant: variantField.parse(fields.variant),
            sizeVariant: sizeVariantField.parse(fields.sizeVariant),
            icon: {
                src: buttonIconField.parse(fields.buttonIcon) || "",
                position: fields.buttonIconPosition,
            },
            css: css`
                ${fields.fullWidth ? `width: 100%;` : null}
            `,
            mergeCss: true,
        };
    }, [fields.buttonIcon, fields.buttonIconPosition, fields.fullWidth, fields.sizeVariant, fields.variant]);
    /* Starter Custom Code - End */

    return (
        /* Starter Custom - Merged StyledWrapper and ContentWrapper styles */
        <ContentWrapper alignment={fields.alignment} {...customCssWrapper} className="wrapper">
            <ResponsiveButton
                {...buttonStyles} // Starter Custom Code
                // Starter Removed - variant
                // Starter Removed - onClick
                className="button"
                // Starter Custom Code
                href={url}
                target={fields.openInNewWindow ? "_blank" : "_self"}
            >
                {fields.label || title || url /* Starter Custom Code */}
            </ResponsiveButton>
        </ContentWrapper>
    );
};

/* Starter Custom Code - Start */
const defaultCustomCss = `& {
}

.button {
}
`;
/* Starter Custom Code - End */

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const advancedTab = {
    displayName: "Advanced",
    sortOrder: 1,
};

export const ContentWrapper = styled.div<InjectableCss & { alignment: string }>`
    display: flex;
    width: 100%;
    justify-content: ${props => props.alignment ?? "flex-start"};
    ${x => (x.alignment === "center" ? "text-align: center;" : null) /* Starter Custom Code */}
    ${injectCss} /* Starter Removed - ";" */
`;

const widgetModule: WidgetModule<Toolkit.FieldDefinition> = {
    component: CmsButton,
    definition: {
        group: "Basic",
        icon: "rectangle-wide",
        fieldDefinitions: [
            {
                ...variantField.definition, // Starter Custom Code
                // Starter Removed - name
                // Starter Removed - displayName
                // Starter Removed - editorTemplate
                // Starter Removed - options
                // Starter Removed - defaultValue
                fieldType: "Contextual",
                tab: basicTab,
            },
            /* Starter Custom Code - Start */
            {
                ...sizeVariantField.definition,
                tab: basicTab,
            },
            {
                ...linkTypeField.definition,
            },
            {
                name: fields.fileUrl,
                displayName: "File",
                fieldType: "Contextual",
                editorTemplate: "FilePickerField",
                defaultValue: "",
                tab: basicTab,
                isVisible: x => x.fields.linkType === linkTypeOptions.file.id,
            },
            {
                name: fields.link,
                displayName: "Destination",
                editorTemplate: "LinkField",
                defaultValue: {
                    value: "",
                    type: "Page",
                },
                fieldType: "Contextual",
                tab: basicTab,
                isVisible: x => x.fields.linkType === linkTypeOptions.destination.id,
            },
            {
                name: fields.openInNewWindow,
                editorTemplate: "CheckboxField",
                fieldType: "Contextual",
                defaultValue: false,
            },
            /* Starter Custom Code - End */
            {
                name: fields.label,
                displayName: "Button Label",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Contextual",
                tab: basicTab,
            },
            // Starter Moved - fields.link - up
            {
                name: fields.alignment,
                displayName: "Button Alignment",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Left", value: "flex-start" },
                    { displayName: "Center", value: "center" },
                    { displayName: "Right", value: "flex-end" },
                ],
                defaultValue: "flex-start", // Starter Custom Code
                fieldType: "Contextual",
                tab: basicTab,
                hideEmptyOption: true, // Starter Custom Code
            },
            /* Starter Custom Code - Start */
            {
                ...buttonIconField.definition,
            },
            {
                name: fields.buttonIconPosition,
                displayName: "Icon Position",
                editorTemplate: "DropDownField",
                fieldType: "General",
                options: [
                    { displayName: "Right", value: "right" },
                    { displayName: "Left", value: "left" },
                ],
                defaultValue: "right",
                hideEmptyOption: true,
                isVisible: x => x.fields.buttonIcon !== buttonIconOptions.none.id,
            },
            {
                name: fields.fullWidth,
                displayName: "Full Width",
                editorTemplate: "CheckboxField",
                fieldType: "Contextual",
                defaultValue: false,
            },
            /* Starter Custom Code - End */
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "Contextual",
                tab: advancedTab,
                defaultValue: defaultCustomCss,
                isVisible: (item, shouldDisplayAdvancedFeatures) => !!shouldDisplayAdvancedFeatures,
                validate: value => {
                    if (value === undefined || value === null) {
                        return "";
                    }

                    const result = cssLinter.parse(value, { silent: true });
                    if (result?.stylesheet?.parsingErrors) {
                        // the error output at this time only has room for one line so we just show the first error
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                    }

                    return "Unable to parse Css";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
        ],
    },
};

export default widgetModule;
